import {FC} from 'react'
import {ClassifiedPost} from '../../core/_models'

type Props = {
  post: ClassifiedPost
}

const CategoryCell: FC<Props> = ({post}) => {
  // Type guard to check if category is an object
  const categoryObj = typeof post.category === 'object' ? post.category : null
  const subCategoryObj = typeof post.subCategory === 'object' ? post.subCategory : null

  return (
    <div className='d-flex flex-column'>
      <span className='text-gray-800 fw-bold mb-1'>
        {categoryObj?.icon && `${categoryObj.icon} `}
        {categoryObj?.name || '-'}
      </span>
      {subCategoryObj?.name && (
        <span className='text-muted fw-semibold text-muted d-block fs-7'>
          {subCategoryObj.name}
        </span>
      )}
    </div>
  )
}

export {CategoryCell}
